import { render } from "./VnfNicsSelection.vue?vue&type=template&id=23e4814c&scoped=true"
import script from "./VnfNicsSelection.vue?vue&type=script&lang=js"
export * from "./VnfNicsSelection.vue?vue&type=script&lang=js"

import "./VnfNicsSelection.vue?vue&type=style&index=0&id=23e4814c&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e4814c"]])

export default __exports__